import { fetchApi } from './client'
import type { PhenotypeExample } from './types'

export interface CreateExampleInput {
  phenotypeId: string
  fileId: string
  fileName: string
  ratesJson: Record<string, unknown>[]
  surchargesJson: Record<string, unknown>[]
  markedBy?: string
}

export async function getExamples(phenotypeId: string): Promise<PhenotypeExample[]> {
  const response = await fetchApi<{ examples: PhenotypeExample[] }>(
    `/api/v1/examples?phenotypeId=${encodeURIComponent(phenotypeId)}`
  )
  return response.examples || []
}

export async function markAsExample(input: CreateExampleInput): Promise<{ exampleId: string }> {
  return fetchApi<{ exampleId: string }>('/api/v1/examples', {
    method: 'POST',
    body: input,
  })
}

export async function removeExample(id: string, phenotypeId: string): Promise<void> {
  return fetchApi<void>(`/api/v1/examples/${id}?phenotypeId=${encodeURIComponent(phenotypeId)}`, { method: 'DELETE' })
}
